import { Component } from '@angular/core';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: '[nc-unsupported-platform]',
  templateUrl: './unsupported-platform.component.html',
  standalone: false,
})
export class UnsupportedPlatformComponent extends AnonymousContentPage {
}
